import React, { useState, useEffect } from "react";

import CsplDateRangePicker from "../../components/DateRangePicker";

import FileStatusTable from "../../components/FileStatusTable/FileStatusTable";

import FileErrorTrends from "../../components/FileErrorTrends/FileErrorTrends";

import { BsArrowLeft } from "react-icons/bs";
import "../../styles/components/FileStatusReport.scss";
import { getFileUploadedReport, getTopErrorCodes } from "../../services";
import { withAppLayout } from "../../hoc";
import { LoaderWrapper } from "../../components";

function FileStatusReport() {
  const [fromDate, setFromDate] = useState(null);

  const [toDate, setToDate] = useState(null);

  const [showSelectedRange, setShowSelectedRange] = useState(false);

  const [dataLoading, setDataLoading] = useState(false);
  const [anyErrors, setAnyErrors] = useState("No Data");

  const [fileData, setFileData] = useState(null);

  const [errorData, setErrorData] = useState(null);

  const [warningData, setWarningData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setDataLoading(true);
      if (showSelectedRange && fromDate && toDate) {
        Promise.all([
          getFileUploadedReport({ fromDate, toDate }),
          getTopErrorCodes({ fromDate, toDate }),
        ])
          .then(([fileResponse, errorResponse]) => {
            setFileData(fileResponse.getFileUploadedReport);
            setErrorData(errorResponse.errors);
            setWarningData(errorResponse.warnings);
            console.log(errorResponse, fileResponse);
            setDataLoading(false);
          })
          .catch((error) => {
            setDataLoading(false);
            setAnyErrors(error);
            console.log("Error occurred while fetching data:", error);
          });
      }
    };

    if (showSelectedRange && fromDate && toDate) {
      fetchData();
    }
  }, [showSelectedRange, fromDate, toDate]);

  const toggleGoClear = () => {
    if (showSelectedRange) {
      setFromDate(null);
      setToDate(null);
      setShowSelectedRange(false);
    } else {
      setShowSelectedRange(true);
    }
  };

  const handleGoClick = (selectedFromDate, selectedToDate) => {
    setFromDate(selectedFromDate);

    setToDate(selectedToDate);
  };

  const getDifferenceInDays = (date1, date2) => {
    const differenceInTime = date2.getTime() - date1.getTime();
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
    return differenceInDays;
  };

  return (
    <div style={{ width: "100%" }}>
      <a className="text-primary">
        <BsArrowLeft className="arrow-icon" />
        Back
      </a>
      <h4 style={{ marginLeft: "40px" }}>File Upload Report</h4>
      <div className="wrapperStyle wrapperStyleWithPadding">
        <p style={{ fontWeight: "bold" }}>Select Date Range</p>

        <div style={{ display: "flex" }}>
          <CsplDateRangePicker
            fromDate={fromDate}
            toDate={toDate}
            onGoClick={handleGoClick}
          />

          {fromDate && toDate && (
            <button className="goButton" onClick={toggleGoClear}>
              {showSelectedRange ? "Clear" : "Go"}
            </button>
          )}
        </div>
      </div>

      {showSelectedRange && fromDate && toDate && (
        <div className="wrapperStyle">
          <div
            style={{
              backgroundColor: "#EAEAEA",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              padding: "15px",
            }}
          >
            <p style={{ marginBottom: "0px" }}>
              <i className="fa-solid fa-circle-info"></i> Showing file upload
              details of {getDifferenceInDays(fromDate, toDate)} days
            </p>
          </div>

          <LoaderWrapper isLoading={dataLoading}>
            <div className=" main">
              <div className="tableSession">
                {fileData && <FileStatusTable data={fileData} />}
              </div>

              <div className="trendsSession">
                {errorData && warningData && (
                  <FileErrorTrends errors={errorData} warnings={warningData} />
                )}
              </div>
            </div>
          </LoaderWrapper>
        </div>
      )}
    </div>
  );
}

export default withAppLayout(FileStatusReport);
